export default "__VITE_ASSET__CYPx4ITx__"